import { NetworkService } from '@agroone-front/shared'
import { PdfResponseDto, Recommendation } from '@agroone/entities'
import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { from, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class RecommendationService {
  private recommendationUrl: string = `${environment.apiUrl}${environment.recommendations}`

  private http = inject(HttpClient)
  private network = inject(NetworkService)

  /**
   * Get all recommendations by cropId
   *
   * @param cropId
   * @returns
   */
  public getByCropId(cropId: number): Observable<Recommendation[]> {
    return from(
      this.network.getAllFromPaginated<Recommendation>(`${this.recommendationUrl}?filter=cropId=${cropId}`, {
        params: {
          noPagination: true,
        },
      }),
    )
  }

  public add(item: Recommendation, opts?: { isMultiReco?: boolean }): Observable<Recommendation[]> {
    const isMultiReco = opts?.isMultiReco ?? (item?.crops?.length ?? 0) > 1
    return this.http.post<Recommendation[]>(this.recommendationUrl, { ...item, isMultiReco })
  }

  public getPdfForRecommendationId(id: number, cropId: number): Observable<PdfResponseDto> {
    return this.http.get<PdfResponseDto>(`${this.recommendationUrl}/${id}/${cropId}/pdf`)
  }

  /**
   * Remove Recommendation by id
   *
   * @param id
   * @returns
   */
  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.recommendationUrl}/${id}`)
  }
}
